module.exports = __webpack_public_path__ + "static/media/Twogirlslaptop.3458ed9b.jpg";